const CHOffers = () => {
	return (
		<>
			<path
				d="M4.59 19.5C4.46 19.5 4.35 19.46 4.28 19.43L1.25 17.24C0.980002 17.05 0.920002 16.67 1.12 16.41C1.31 16.14 1.69 16.08 1.95 16.28L4.52 18.15C4.9 17.72 5.23 17.27 5.55 16.84C5.81 16.49 6.06 16.15 6.32 15.84C6.53 15.58 6.91 15.55 7.16 15.76C7.41 15.97 7.45 16.35 7.24 16.6C7 16.9 6.76 17.22 6.51 17.55C6.15 18.04 5.78 18.54 5.39 18.96L5.31 19.05C5.05 19.41 4.79 19.51 4.58 19.51L4.59 19.5Z"
				fill="#C68486"
			/>
			<path
				d="M20.19 8.93002C29.08 8.41002 26 21.52 18.34 25.05C6.93 30.31 2.74 9.96002 20.19 8.93002Z"
				fill="#F7D9D8"
			/>
			<path
				d="M20.32 22.97H20.3C18.63 22.97 17.76 21.6 17.65 20.25C17.53 18.8 18.26 17.18 19.89 16.89C20.86 16.71 21.71 17.05 22.29 17.83C23.04 18.84 23.16 20.41 22.57 21.57C22.12 22.46 21.3 22.97 20.31 22.97H20.32ZM20.38 18.04C20.29 18.04 20.2 18.04 20.11 18.06C19.18 18.22 18.77 19.23 18.85 20.14C18.91 20.89 19.34 21.76 20.32 21.77C20.86 21.74 21.27 21.52 21.52 21.02C21.9 20.27 21.82 19.18 21.34 18.53C21.09 18.2 20.77 18.03 20.38 18.03V18.04Z"
				fill="#C68486"
			/>
			<path
				d="M11.44 23.13C11.33 23.13 11.23 23.1 11.13 23.04C10.85 22.87 10.76 22.5 10.93 22.22L19.37 8.38999C19.54 8.10999 19.91 8.01999 20.19 8.18999C20.47 8.35999 20.56 8.72999 20.39 9.00999L11.95 22.84C11.84 23.02 11.64 23.13 11.44 23.13Z"
				fill="#C68486"
			/>
			<path
				d="M11.17 15.14C9.78 15.14 8.72 14.09 8.56 12.49C8.4 10.97 9.18 9.24 10.94 9.03C11.86 8.92 12.66 9.28 13.21 10.03C13.92 11 14.06 12.46 13.55 13.59C13.14 14.49 12.38 15.04 11.42 15.13C11.33 15.13 11.25 15.14 11.16 15.14H11.17ZM11.26 10.21C11.2 10.21 11.15 10.21 11.09 10.22C9.96 10.35 9.67 11.58 9.75 12.37C9.83 13.15 10.31 14.03 11.32 13.94C11.85 13.89 12.24 13.61 12.47 13.1C12.8 12.37 12.7 11.36 12.25 10.74C11.99 10.39 11.66 10.21 11.26 10.21Z"
				fill="#C68486"
			/>
			<path
				d="M15.95 27.74C12.62 27.74 9.38 26.38 6.83 23.82C6.6 23.59 6.6 23.21 6.83 22.98C7.06 22.75 7.44 22.75 7.67 22.98C10.82 26.14 15.12 27.29 19.17 26.07C23.05 24.9 25.85 21.82 26.65 17.82C26.9 16.59 27.13 15.15 27 13.82C26.97 13.49 27.21 13.2 27.53 13.17C27.87 13.14 28.15 13.38 28.18 13.71C28.33 15.19 28.08 16.74 27.81 18.06C26.92 22.49 23.82 25.91 19.5 27.21C18.32 27.57 17.11 27.74 15.92 27.74H15.95Z"
				fill="#C68486"
			/>
			<path
				d="M25.15 15.9C25 15.9 24.85 15.84 24.74 15.73C24.5 15.5 24.49 15.12 24.72 14.89C25.02 14.58 25.3 14.26 25.58 13.93C25.91 13.55 26.23 13.18 26.58 12.82C26.72 12.66 26.78 12.58 26.86 12.52C27.26 12.03 27.65 12.12 27.85 12.22L30.76 14.35C31.03 14.55 31.08 14.92 30.89 15.18C30.69 15.45 30.32 15.5 30.06 15.31L27.59 13.49C27.59 13.49 27.59 13.49 27.58 13.5C27.54 13.55 27.49 13.6 27.45 13.65C27.12 13.99 26.81 14.35 26.5 14.71C26.2 15.05 25.91 15.39 25.6 15.71C25.48 15.83 25.33 15.89 25.17 15.89L25.15 15.9Z"
				fill="#C68486"
			/>
			<path
				d="M4.35 18.85C4.06 18.85 3.81 18.64 3.76 18.34C3.26 15.08 4.17 11.68 6.26 9C8.35 6.32 11.44 4.61 14.73 4.31C18.43 3.97 21.77 5.24 24.65 8.08C24.89 8.31 24.89 8.69 24.65 8.92C24.42 9.15 24.04 9.16 23.81 8.92C21.15 6.3 18.21 5.18 14.84 5.49C11.88 5.76 9.09 7.3 7.2 9.72C5.31 12.14 4.49 15.21 4.94 18.14C4.99 18.47 4.77 18.77 4.44 18.82C4.41 18.82 4.38 18.82 4.35 18.82V18.85Z"
				fill="#C68486"
			/>
		</>
	);
};

export default CHOffers;
